/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkCreateProductMappingFromRequest } from '../fn/product-mapping-request/bulk-create-product-mapping-from-request';
import { BulkCreateProductMappingFromRequest$Params } from '../fn/product-mapping-request/bulk-create-product-mapping-from-request';
import { createProductMappingFromRequest } from '../fn/product-mapping-request/create-product-mapping-from-request';
import { CreateProductMappingFromRequest$Params } from '../fn/product-mapping-request/create-product-mapping-from-request';
import { CreateProductMappingResponse } from '../models/create-product-mapping-response';
import { deleteProductMappingRequest } from '../fn/product-mapping-request/delete-product-mapping-request';
import { DeleteProductMappingRequest$Params } from '../fn/product-mapping-request/delete-product-mapping-request';
import { getProductMappingRequest } from '../fn/product-mapping-request/get-product-mapping-request';
import { GetProductMappingRequest$Params } from '../fn/product-mapping-request/get-product-mapping-request';
import { getProductMappingRequests } from '../fn/product-mapping-request/get-product-mapping-requests';
import { GetProductMappingRequests$Params } from '../fn/product-mapping-request/get-product-mapping-requests';
import { PagedModelProductMappingRequestModel } from '../models/paged-model-product-mapping-request-model';
import { patchProductMappingRequest } from '../fn/product-mapping-request/patch-product-mapping-request';
import { PatchProductMappingRequest$Params } from '../fn/product-mapping-request/patch-product-mapping-request';
import { ProductMappingRequestModel } from '../models/product-mapping-request-model';


/**
 * Product mapping request management. Mapping requests are created by sellers via POST /products. An admin reviews and approves them, which creates the actual product mapping enabling price/stock sync for that SKU. Required authority (one of): PRODUCT_MAPPING_REQUEST_ADMIN, EASYLOT_ADMIN, PRICE_SYNC_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ProductMappingRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bulkCreateProductMappingFromRequest()` */
  static readonly BulkCreateProductMappingFromRequestPath = '/product-mappings/requests/create-product-mappings';

  /**
   * Bulk accept mapping requests and create product mappings.
   *
   * Accepts multiple product mapping requests in a single call and creates the corresponding product mappings.
   * The request body is a map of `{ productMappingRequestId → CreateProductMappingRequest }`.
   * The response is a map of `{ productMappingRequestId → CreateProductMappingResponse }` with the outcome per request.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkCreateProductMappingFromRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateProductMappingFromRequest$Response(params: BulkCreateProductMappingFromRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: CreateProductMappingResponse;
}>> {
    const obs = bulkCreateProductMappingFromRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Bulk accept mapping requests and create product mappings.
   *
   * Accepts multiple product mapping requests in a single call and creates the corresponding product mappings.
   * The request body is a map of `{ productMappingRequestId → CreateProductMappingRequest }`.
   * The response is a map of `{ productMappingRequestId → CreateProductMappingResponse }` with the outcome per request.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkCreateProductMappingFromRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkCreateProductMappingFromRequest(params: BulkCreateProductMappingFromRequest$Params, context?: HttpContext): Observable<{
[key: string]: CreateProductMappingResponse;
}> {
    const resp = this.bulkCreateProductMappingFromRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
[key: string]: CreateProductMappingResponse;
}>): {
[key: string]: CreateProductMappingResponse;
} => r.body)
    );
  }

  /** Path part for operation `createProductMappingFromRequest()` */
  static readonly CreateProductMappingFromRequestPath = '/product-mappings/request/{productMappingRequestId}/create-product-mapping';

  /**
   * Accept a mapping request and create a product mapping.
   *
   * Accepts a single product mapping request and creates the corresponding product mapping (SKU → productId).
   * Once the mapping is created, the seller can synchronize prices and stock for that SKU.
   *
   * For bulk acceptance, use `POST /product-mappings/requests/create-product-mappings`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductMappingFromRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductMappingFromRequest$Response(params: CreateProductMappingFromRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
    const obs = createProductMappingFromRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Accept a mapping request and create a product mapping.
   *
   * Accepts a single product mapping request and creates the corresponding product mapping (SKU → productId).
   * Once the mapping is created, the seller can synchronize prices and stock for that SKU.
   *
   * For bulk acceptance, use `POST /product-mappings/requests/create-product-mappings`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProductMappingFromRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductMappingFromRequest(params: CreateProductMappingFromRequest$Params, context?: HttpContext): Observable<ProductMappingRequestModel> {
    const resp = this.createProductMappingFromRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingRequestModel>): ProductMappingRequestModel => r.body)
    );
  }

  /** Path part for operation `getProductMappingRequest()` */
  static readonly GetProductMappingRequestPath = '/product-mappings/request/{productMappingRequestId}';

  /**
   * Get product mapping request by ID.
   *
   * Returns a single product mapping request by its UUID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMappingRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappingRequest$Response(params: GetProductMappingRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
    const obs = getProductMappingRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get product mapping request by ID.
   *
   * Returns a single product mapping request by its UUID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductMappingRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappingRequest(params: GetProductMappingRequest$Params, context?: HttpContext): Observable<ProductMappingRequestModel> {
    const resp = this.getProductMappingRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingRequestModel>): ProductMappingRequestModel => r.body)
    );
  }

  /** Path part for operation `deleteProductMappingRequest()` */
  static readonly DeleteProductMappingRequestPath = '/product-mappings/request/{productMappingRequestId}';

  /**
   * Delete product mapping request.
   *
   * Permanently deletes a product mapping request. The associated product data submitted by the seller is discarded.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProductMappingRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductMappingRequest$Response(params: DeleteProductMappingRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteProductMappingRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete product mapping request.
   *
   * Permanently deletes a product mapping request. The associated product data submitted by the seller is discarded.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProductMappingRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteProductMappingRequest(params: DeleteProductMappingRequest$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteProductMappingRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchProductMappingRequest()` */
  static readonly PatchProductMappingRequestPath = '/product-mappings/request/{productMappingRequestId}';

  /**
   * Partially update product mapping request.
   *
   * Applies a partial update to an existing product mapping request (e.g. updating review status or notes).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchProductMappingRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProductMappingRequest$Response(params: PatchProductMappingRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
    const obs = patchProductMappingRequest(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Partially update product mapping request.
   *
   * Applies a partial update to an existing product mapping request (e.g. updating review status or notes).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchProductMappingRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchProductMappingRequest(params: PatchProductMappingRequest$Params, context?: HttpContext): Observable<ProductMappingRequestModel> {
    const resp = this.patchProductMappingRequest$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductMappingRequestModel>): ProductMappingRequestModel => r.body)
    );
  }

  /** Path part for operation `getProductMappingRequests()` */
  static readonly GetProductMappingRequestsPath = '/product-mappings/requests';

  /**
   * List product mapping requests.
   *
   * Returns a paginated list of product mapping requests. Supports filtering via query criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMappingRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappingRequests$Response(params: GetProductMappingRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductMappingRequestModel>> {
    const obs = getProductMappingRequests(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List product mapping requests.
   *
   * Returns a paginated list of product mapping requests. Supports filtering via query criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductMappingRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMappingRequests(params: GetProductMappingRequests$Params, context?: HttpContext): Observable<PagedModelProductMappingRequestModel> {
    const resp = this.getProductMappingRequests$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProductMappingRequestModel>): PagedModelProductMappingRequestModel => r.body)
    );
  }

}
